export const getToken = () => localStorage.getItem('token');

export const setToken = (token) => localStorage.setItem('token', token);

export const removeToken = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

export const getUser = () => {
  try {
    const raw = localStorage.getItem('user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const setUser = (user) => localStorage.setItem('user', JSON.stringify(user));

export const isAuthenticated = () => !!getToken();

export const hasRole = (role) => {
  const user = getUser();
  return user?.role === role;
};
